import Vue from 'vue';
import * as VuexHelpers from 'vuex-class';
import { createDecorator } from 'vue-class-component';
import { StateBindingHelper, VuexDecorator, BindingHelper } from 'vuex-class/lib/bindings';

function createHelper(
  vuexHelper: BindingHelper,
) {
  function helper(target: Vue, key: string): void;
  function helper(namespace: string, ...args: string[]): VuexDecorator;
  function helper(a: any, ...args: any[]): void | VuexDecorator {
    if (typeof a !== 'string') {
      return vuexHelper(a, ...args);
    }

    return vuexHelper([a, ...args].join('/'));
  }

  return helper;
}

export const State = createHelper(VuexHelpers.State);
export const Getter = createHelper(VuexHelpers.Getter);
export const Mutation = createHelper(VuexHelpers.Mutation);
export const Action = createHelper(VuexHelpers.Action);

export { Vue };
export * from 'vue-property-decorator';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/vue.ts